module.exports = __webpack_public_path__ + "static/img_9628-1aa551b16b9075d24597f43cfa8a431a.webp";